import _Promise from 'babel-runtime/core-js/promise';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { MyAccountInterface } from '@central-products/interface-myaccount';
import { clearCache } from '@myaccount/utils';
import { TranslatorProvider, withTranslator } from '@wh/ui-translations';
import { cacheKeysToRemove } from './constants';

var LazyMyAccountDropdown = lazy(function () {
  return import('@myaccount/myaccount-dropdown').then(function (_ref) {
    var MyAccountDropdown = _ref.MyAccountDropdown;
    return { default: MyAccountDropdown };
  });
});

var MyAccount = function (_MyAccountInterface) {
  _inherits(MyAccount, _MyAccountInterface);

  function MyAccount(config, dependencies, transport) {
    _classCallCheck(this, MyAccount);

    var _this = _possibleConstructorReturn(this, (MyAccount.__proto__ || _Object$getPrototypeOf(MyAccount)).call(this));

    _this.domNode = null;
    var domNodeId = config.domNodeId,
        langCode = config.langCode,
        translations = config.translations,
        jurisdiction = config.jurisdiction,
        vertical = config.vertical,
        neverOpen = config.neverOpen;


    _this.sessionManager = dependencies['session-manager'];
    _this.dataAccessService = dependencies['data-access-service'];
    _this.domNodeId = domNodeId || 'cp-ma-wrapper';
    _this.jurisdiction = jurisdiction;
    _this.langCode = langCode;
    _this.translations = translations;
    _this.transport = transport;
    _this.vertical = vertical;
    _this.neverOpen = neverOpen;
    return _this;
  }

  _createClass(MyAccount, [{
    key: 'start',
    value: function start() {
      var _this2 = this;

      this.domNode = document.getElementById(this.domNodeId);

      if (!this.domNode) {
        return _Promise.reject(new Error('Could not find node with ID ' + this.domNodeId));
      }

      return this.dataAccessService.getClient().then(function (client) {
        _this2.apolloClient = client;
        _this2.render();
        return {};
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      if (this.domNode) {
        ReactDOM.unmountComponentAtNode(this.domNode);
      }
      clearCache(this.apolloClient, cacheKeysToRemove);
      return _Promise.resolve({});
    }
  }, {
    key: 'render',
    value: function render() {
      var MyAccountDropdownWithTranslator = withTranslator(LazyMyAccountDropdown);

      if (this.domNode) {
        ReactDOM.render(React.createElement(
          TranslatorProvider,
          { translations: this.translations },
          React.createElement(
            Suspense,
            { fallback: null },
            React.createElement(MyAccountDropdownWithTranslator, {
              gqlClient: this.apolloClient,
              jurisdiction: this.jurisdiction,
              langCode: this.langCode,
              sessionManager: this.sessionManager,
              transport: this.transport,
              vertical: this.vertical,
              neverOpen: this.neverOpen
            })
          )
        ), this.domNode);
      }
    }
  }]);

  return MyAccount;
}(MyAccountInterface);

export default MyAccount;